exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".question-title-container{display:grid;grid-template-columns:auto 1fr;gap:15px}.question-title-container span{display:flex;flex-shrink:0;justify-content:center;align-items:center;position:relative;z-index:1;width:20px;height:20px;font-weight:700;font-size:16px;white-space:nowrap;color:#fff;background:#d06f6e;border-radius:3px}.question-title-container span:before{position:absolute;right:-7px;bottom:2.5px;z-index:-1;width:15px;height:15px;content:\"\";transform:rotate(45deg);background-color:#d06f6e;border-radius:3px}.question-title-container p{color:#fff;font-weight:600;font-size:20px;margin:0}", ""]);

// exports
